import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "@fontsource/playfair-display/400.css";
import "@fontsource/playfair-display/500.css";
import "@fontsource/playfair-display/600.css";
import "@fontsource/playfair-display/700.css";
import "@fontsource/lato/400.css";
import "@fontsource/lato/700.css";
import "@fontsource/noto-sans-arabic/400.css";
import "@fontsource/noto-sans-arabic/500.css";
import "@fontsource/noto-sans-arabic/600.css";
import "@fontsource/noto-sans-arabic/700.css";
import "@fontsource/amiri/400.css";
import "@fontsource/amiri/700.css";
import "./index.css";
import { initPrefetchTelemetry } from "@/utils/prefetchTelemetry";

// Start the resource-timing observer before React mounts so early product
// image loads count toward the baseline. Exposes window.__prefetchStats.
initPrefetchTelemetry();

createRoot(document.getElementById("root")!).render(<App />);
